module.exports = {
    "frames": [
        {
            "time": 0,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-push-blue/p-push-blue1_.png").default
        },
        {
            "time": 100,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-push-blue/p-push-blue2_.png").default
        },
        {
            "time": 200,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-push-blue/p-push-blue3_.png").default
        },
        {
            "time": 300,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-push-blue/p-push-blue4_.png").default
        },
        {
            "time": 400,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-push-blue/p-push-blue5_.png").default
        },
        {
            "time": 500,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-push-blue/p-push-blue6_.png").default
        },
        {
            "time": 600,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-ready-blue/p-ready-blue1_.png").default
        }
    ]
}
